import BaseRepository from "@/services/resources/repository";
import byPerson from "@/services/resources/mixins/query-by-person";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byPerson);
    }

    bySector(id) {
        return this.try(
            this.baseQuery().where('sectorId', id).get()
        );
    }

    byPerson(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .where('personId', id)
                    .get()
            )
        )
    }
}

export default Repository;
